import React,{useEffect} from "react";

import ServiceTemplate from "../components/ServiceTemplate";
import robBanner from "../images/robotic-1.png";
import robBig from "../images/robotic-2.png";
import robCollage from "../images/robotic-3.png";
 import {
  FaCertificate,
  FaCogs,
  FaTools,
  FaPuzzlePiece,
  FaBrain

} from "react-icons/fa";


export default function Robotics() {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);


const sidebar = [
{
    title: "Annual Robotics Challenge & Certificates",
    icon: FaCertificate,
  },
  {
    title: "Safe & Durable Kits with Warranty and Backup Spares",
    icon: FaTools,
  },
  {
    title: "Logic & Problem-Solving Skills",
    icon: FaPuzzlePiece,
  },
  {
    title: "Mechanical, Electronics & Coding Skills",
    icon: FaCogs,
  },
  {
    title: "AI & IoT Exposure for Higher Grades",
    icon: FaBrain,
  },
];

  const features = [
    "Automation system design & deployment",
    "Robots for assembly, welding, packaging",
    "Vision & AI integration",
    "PLC/SCADA integration",
    "Field commissioning & support",
  ];
  return <ServiceTemplate
    title="Robotics"
    bannerImage={robBanner}
    bigImage={robBig}
    collageImage={robCollage}
    sidebarItems={sidebar}
    features={features}
  />;
}
